/**
 * 运营商切换相关工具函数
 */

// 获取当前选中的运营商ID
export function getCurrentDistributorId() {
  return window.sessionStorage.getItem('currentDistributorId') || ''
}

// 设置当前选中的运营商ID
export function setCurrentDistributorId(id) {
  if (id) {
    window.sessionStorage.setItem('currentDistributorId', id)
  } else {
    window.sessionStorage.removeItem('currentDistributorId')
  }
}

// 获取当前选中的运营商名称
export function getCurrentDistributorName() {
  return window.sessionStorage.getItem('currentDistributorName') || ''
}

// 设置当前选中的运营商名称
export function setCurrentDistributorName(name) {
  if (name) {
    window.sessionStorage.setItem('currentDistributorName', name)
  } else {
    window.sessionStorage.removeItem('currentDistributorName')
  }
}

// 清除运营商选择信息
export function clearDistributorInfo() {
  window.sessionStorage.removeItem('currentDistributorId')
  window.sessionStorage.removeItem('currentDistributorName')
}
